import { Box } from '@vp/swan';
import type { ReactNode } from 'react';

export function ConfirmationCard({ children, width }: { children: ReactNode; width?: string }) {
    return (
        <Box
            backgroundColor="standard"
            style={{
                border: '1px solid var(--swan-sem-color-border-subtle)',
                borderRadius: 'var(--swan-sem-border-radius-standard)',
                overflow: 'hidden',
                width,
            }}
        >
            {children}
        </Box>
    );
}
